export default __webpack_public_path__ + "static/media/I0006.4a82f5f8.png";